import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';


import AddBuilderAgencyForm from '../Components/AddBuilderAgencyForm';
// import AddCompanyForm from '../../../Components/Companies/AddCompanyForm';

export default function AddBuilderAgencyPage() {

  


  return (
    // component="main" 
    <Box  sx={{ flexGrow: 1, p: 3 }}>
        <Container>
            <AddBuilderAgencyForm/>
        </Container>
    </Box>
  )
}
